import { useContext, useState, useEffect, useRef, JSX } from 'react';
import { Handle, Node, Position, ReactFlowInstance, useReactFlow, useUpdateNodeInternals, Edge } from '@xyflow/react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {
    Settings,
    Add,
    Remove,
    Delete
} from '@mui/icons-material';
import { IconButton } from "@mui/material";
import { UpdateNodeInternals } from "@xyflow/system";

function WorkflowMergeNode({ id, data }: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    let startingNumber: number = data.inputCount ?? 2;
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [inputCount, setInputCount] = useState(startingNumber);
    const updateNodeInternals: UpdateNodeInternals = useUpdateNodeInternals();
    // console.log(data);

    function handleAddHandle(): void {
        if (inputCount < 10) {
            let count: number = inputCount + 1;
            setInputCount(count);
            updateNodeInternals(id);
            updateNode(count)
        }
    }

    function updateNode(count: number): void {
        let node: Node = reactFlowInstance.getNode(id);
        node.data.inputCount = count;

        let allNodes: Node[] = reactFlowInstance.getNodes();
        let newAllNodes: Node[] = [node];
        for (const nde of allNodes) {
            if (nde.id !== node.id) {
                newAllNodes.push(nde);
            }
        }
        // reactFlowInstance.setNodes(newAllNodes);
        context.updateLayoutNodes(newAllNodes);

    }

    function handleRemoveHandle(): void {
        if (inputCount > 2) {
            let count: number = inputCount - 1;
            setInputCount(count);
            updateNodeInternals(id);
            updateNode(count)

            let edges: Edge[] = reactFlowInstance.getEdges();
            let newEdges: Edge[] = [];
            for (const edge of edges) {
                if (edge.target !== ('merge-target-' + count)) {
                    newEdges.push(edge);
                }
            }
            // reactFlowInstance.setEdges(newEdges);
            context.updateLayoutEdges(newEdges);
        }
    }

    function handleShowMergeConfigurationClick(): void {
        const node: Node = reactFlowInstance.getNode(id);
        context.setActiveEditMergeNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    function handleNodeDelete(): void {
        let nodes: Node[] = reactFlowInstance.getNodes();
        let updatedNodes: Node[] = nodes.filter( (node: any): boolean => node.id !== id );
        context.updateLayoutNodes(updatedNodes);
    }

    return (
        <div className={ "workflow-node merge " + id + " " + (successfulTest()) } >
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            { Array.from({ length: inputCount }).map( (_: any, index: number): JSX.Element => {
                const left: number = (100 / (inputCount + 1))
                const leftValue: string = left * (index + 1) + '%'
                return (
                    <Handle
                        key={ 'merge-target-' + index + '-handle' }
                        type="target"
                        id={ 'merge-target-' + index }
                        style={ { left: leftValue  } }
                        position={Position.Top}
                    >
                        <span className="handle-label top" >{ "Input " + (index + 1)  }</span>
                    </Handle>
                );
            } )  }

            <div className="node__layout">
                <div className="layout__top">
                    <span className="merge-icon" />
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Merge Flow Node' }
                    </span>
                </div>
                <div className="layout__middle">
                    <IconButton onClick={ handleNodeDelete } >
                        <Delete />
                    </IconButton>
                </div>
                <div className="layout__bottom">
                    {/*<span className="action-span nodrag" onClick={ handleShowMergeConfigurationClick }>*/}
                    {/*    <Settings />*/}
                    {/*</span>*/}
                    <div className="top__buttons">
                        <span className="button nodrag" title="Add Input" onClick={ handleAddHandle }>
                            <Add />
                        </span>
                        <span className="button nodrag" title="Remove Input" onClick={ handleRemoveHandle }>
                            <Remove />
                        </span>
                    </div>
                </div>
            </div>
            <Handle
                type="source"
                position={Position.Bottom}
                id="merge-source"
            >
                <span className="handle-label bottom" >{ "Output" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowMergeNode;